$(document).ready(function () {

    var isEnabled = $('input:hidden.page-conf').data("postalcode-validation");
    if (isEnabled) {

        InitPostalCodeLookup();
    }
});

function InitPostalCodeLookup() {

    var $areaInput = $("input.area");
    var postalCodeAreasResults = $(".postal-code-areas");

    $(document).on("click", ".shipping-info input.area", function (event) {
        $('input.PostalCode').focus().select();
    });

    $(document).bind("contextmenu", ".shipping-info input.area", function (e) {
        if ($(".shipping-info input.area").is(":focus")) {
            $('input.PostalCode').focus().select();
            return false;
        }
        return true;
    });

    $(document).on("click", ".shipping-info input.disabled", function (event) {
        event.preventDefault();
    });

    $(document).on("keydown", ".shipping-info input.disabled", function (event) {
        event.preventDefault();
    });

    $(document).on("click", ".PostalCodeLookUp li a", function (event) {

        var area = $(this).attr('data-area');

        $areaInput.val(area);
        $areaInput.attr('value', area);

        postalCodeAreasResults.hide();

        //hide AreaPostCodeValidator
        $areaInput.parent().siblings('input').removeClass('error');
        $areaInput.parent().siblings('label').removeClass('error');
        $areaInput.parent().parent('div.input').removeClass('error');
        $areaInput.parent().siblings('div').removeClass('error');
        $areaInput.parent().parent().find('.vldShippingAreaPostCode').hide();
    });

    if ($("input.PostalCode").length > 0) {
        $("input.PostalCode").keyup(
            $.debounce(500, function () {
                var postalCode = $("input.PostalCode").val();
                if (!isNaN(postalCode) && ((countryCode === "GR" && postalCode.length == 5) || (countryCode === "CY" && postalCode.length == 4) || (countryCode === "CL" && postalCode.length == 7) || (countryCode === "HU" && postalCode.length == 4) || (countryCode === "BG" && postalCode.length == 4))) {
                    if (postalCode.length > 0) {
                        $postalCodeAreasResults.closest('.form-row').addClass('x-loading');
                        $.ajax({
                            type: "POST",
                            dataType: 'json',
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/PostalCodeRegionLookUp'),
                            async: false,
                            data: "{\"postalCode\":" + postalCode + ", \"languageId\": " + 1 + "}",
                            error: function (data) {
                            },
                            success: function (data) {
                                if (data.d != "invalid_code") {
                                    postalCodeAreasResults.html(data.d);
                                    postalCodeAreasResults.show();
                                    $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
                                } else {
                                    alert(LhApp.Function.getText('Common:Checkout_PostalCodeIsNotValid'));
                                    $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
                                    $areaInput.val('');
                                    postalCodeAreasResults.hide();

                                    //hide AreaPostCodeValidator
                                    $areaInput.parent().siblings('input').removeClass('error');
                                    $areaInput.parent().siblings('label').removeClass('error');
                                    $areaInput.parent().parent('div.input').removeClass('error');
                                    $areaInput.parent().siblings('div').removeClass('error');
                                    $areaInput.parent().parent().find('.vldShippingAreaPostCode').hide();
                                    $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
                                }
                            }
                        });
                    }
                    $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
                } else {
                    $areaInput.val('');
                    postalCodeAreasResults.hide();

                    //hide AreaPostCodeValidator
                    $areaInput.parent().siblings('input').removeClass('error');
                    $areaInput.parent().siblings('label').removeClass('error');
                    $areaInput.parent().parent('div.input').removeClass('error');
                    $areaInput.parent().siblings('div').removeClass('error');
                    $areaInput.parent().parent().find('.vldShippingAreaPostCode').hide();
                }
            })
        );
    }

}

var validateArea = function ($postCode, $area, $countries) {
    var result = true;
    var countryCode = $countries.val();
    var postalCode = $postCode.val();
    var areasCount = $('*:selected', $countries).data('areascount') || 0;
    if (areasCount < 2) return result;
    if (!isNaN(postalCode)) {
        if ((countryCode === "GR" && postalCode.length == 5) || (countryCode === "CY" && postalCode.length == 4) || (countryCode === "CL" && postalCode.length == 7) || (countryCode === "HU" && postalCode.length == 4) || (countryCode === "BG" && postalCode.length == 4)) {
            if (postalCode.length > 0) {

                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/AreaLookUp'),
                    async: false,
                    data: JSON.stringify({
                        countryCode: countryCode,
                        postalCode: postalCode
                    }),
                    error: function (data) { },
                    success: function (data) {
                        if (data.d != "invalid_code") {

                            var areasForPostalCode = $.parseHTML(data.d);

                            var areasPostalCodeMapping = [];

                            $('> li > a', areasForPostalCode).each(function (index, elem) {
                                areasPostalCodeMapping.push($(elem).data('area') + '|' + $(elem).data('post-code'));
                            })

                            if ($.inArray($area.val().trim() + '|' + $postCode.val().trim(), areasPostalCodeMapping) === -1) {
                                result = false;
                            }

                        } else {
                            result = false;
                            $area.val('');
                        }
                    }
                });
            }
        } else {
            result = false;
        }
    } else {
        result = false;
    }

    return result;
};
